const HIERARCHY_MODAL_LOAD_TYPE = "HIERARCHY_MODAL_LOAD";

export const reducer = (state = {}, action) => {
  switch (action.type) {
    case HIERARCHY_MODAL_LOAD_TYPE:
      return {
        data: action.data,
        mode: action.mode,
        sourceHierarchy: action.sourceHierarchy
      };
    default:
      return state;
  }
};

export const LoadHierarchyModal = (data, mode, sourceHierarchy) => ({
  type: HIERARCHY_MODAL_LOAD_TYPE,
  data,
  mode,
  sourceHierarchy
});
